import utils from "../../../utils/utils.js";

export default {
  async fetchSuperUserManuelAccountCollects(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetManuelAccountCollects?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setSuperUserManuelAccountCollects", responseData.data);
  },

  async postSuperUserManuelAccountCollect(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateManuelAccountCollect`,
      "POST",
      null,
      payload
    );
  },
};
